import { useState } from 'react';
import { useAcceptQueue } from '../model/accept-queue.queries.js';
import { AcceptBar } from './AcceptBar.js';
import { AcceptSheet } from './AcceptSheet.js';

/**
 * QABUL QILISH oqimi — suzuvchi tugma, oyna va ular egallagan bo'shliq.
 *
 * Sahifaga BITTA element bo'lib qo'shiladi: `<AcceptQueue />`. Ilgari
 * bu uchtasi `/inbox` ichida qo'lda yig'ilgan edi va boshqaruv paneliga
 * ham kerak bo'lganda ayni o'sha simlar ikkinchi marta tortilardi —
 * ikki nusxa esa asta-sekin farq qila boshlaydi.
 *
 * Ma'lumot ham, ko'rinish sharti ham `useAcceptQueue` dan keladi. Hook
 * `useInbox` keshiga tayanadi, ya'ni sahifa qaysi bo'lishidan qat'i
 * nazar son bitta manbadan chiqadi va ikki joyda ikki xil bo'lmaydi.
 *
 * Oyna hech qanday so'rov yubormaydi: qabulni tasdiqlash uchun rasm
 * bilan dalolatnoma kerak va u talabnoma sahifasida yuklanadi. Bu yerda
 * kartochka faqat o'sha sahifaga olib boradi.
 *
 * Qaytib kelganda ro'yxat, kartochkadagi son va pastki qatordagi nuqta
 * o'z-o'zidan yangilangan bo'ladi — tasdiqlash `useTransition` orqali
 * o'tadi va u navbat keshini bekor qiladi.
 */
export interface AcceptQueueProps {
  /**
   * Talabnoma sahifasiga o'tish.
   *
   * Marshrutlash sahifa darajasida qoladi (`InboxPage` bilan bir uslub):
   * bu komponent qaysi route qanday atalishini bilmaydi va shu sababli
   * ikkala sahifada ham, testda ham bir xil ishlaydi.
   */
  onOpenRequisition: (requisitionId: string) => void;
}

export const AcceptQueue = ({ onOpenRequisition }: AcceptQueueProps) => {
  const queue = useAcceptQueue();
  const [open, setOpen] = useState(false);

  if (!queue.showBar) return null;

  return (
    <>
      {/*
        Bo'shliq — SAHIFA oqimida, tugma esa `fixed`. Shu sababli u shu
        yerda, komponentning o'zida turadi: har sahifa pastki paddingni
        o'zi hisoblasa, bittasi albatta unutilardi va oxirgi qator tugma
        ostida qolib ketardi.
      */}
      <div aria-hidden className="h-[4.25rem] shrink-0" />

      <AcceptBar count={queue.count} onOpen={() => setOpen(true)} />

      <AcceptSheet
        open={open}
        onClose={() => setOpen(false)}
        rows={queue.rows}
        warehouseNames={queue.warehouseNames}
        pending={queue.isLoading}
        /* Oyna avval YOPILADI, keyin o'tiladi: yopilmasa u yangi sahifa
           ustida osilib qolardi va odam orqaga qaytganda uni qo'lda
           yopishga majbur bo'lardi. */
        onOpenRow={(row) => {
          setOpen(false);
          onOpenRequisition(row.id);
        }}
      />
    </>
  );
};
